var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkContainedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5L0 5L2 3.5L5 6.5L12 0L14 1.5L5 10.5Z",
    fill: "#46A314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkContainedIcon);
export default __webpack_public_path__ + "static/media/checkmarkContainedIcon.ad9328bdb61ba23dfd0e85a31d7d8e5a.svg";
export { ForwardRef as ReactComponent };